module.exports = __webpack_public_path__ + "img/cloud11.ab3efce3.png";